import { Components } from '@mui/material';

export const buttonBaseConfigs: Components['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
};
